import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

export default function ModalUpdateStato({
  // Modal stuff
  isOpen,
  title,
  toggle,
  // Stati
  stati,
  initialStato,
  // Is stat required?
  required,
  // Data stuff
  saving,
  onSave,
}) {
  const [selectedStato, setSelectedStato] = useState(initialStato)
  const [dataArrivo, setDataArrivo] = useState('')

  // Reset selected stato on modal open / close
  useEffect(() => setSelectedStato(initialStato), [initialStato])

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {title}
      </ModalHeader>
      <ModalBody>
        <select
          className='form-control'
          value={selectedStato || ''}
          onChange={e => setSelectedStato(e.target.value)}>
          <option value={''}>{'-- Seleziona Stato ---'}</option>
          {stati.map(stato => (
            <option key={stato.nome} value={stato.nome}>{stato.nome}</option>
          ))}
        </select>
        {selectedStato === 'ARRIVATO' && (
          <input
            type="date"
            className='form-control mt-3'
            value={dataArrivo}
            onChange={e => setDataArrivo(e.target.value)}
            placeholder="Data di arrivo"
          />
        )}
      </ModalBody>
      <ModalFooter className='d-flex justify-content-between'>
        <Button color="secondary" disabled={saving} onClick={toggle}>Chiudi</Button>
        <Button
          color="success"
          disabled={saving || (required ? !selectedStato || (selectedStato === 'ARRIVATO' && !dataArrivo) : false)}
          onClick={() => onSave(selectedStato, dataArrivo)}>Salva</Button>
      </ModalFooter>
    </Modal>
  )
}
